<ng-container [ngSwitch]="mode">
  <div *ngSwitchCase="'compact'" class="small-sidebar-search">
    <button
      type="button"
      class="small-sidebar-search-toggle"
      (click)="open()"
      [attr.title]="t?.buscaraccesos"
      [attr.aria-label]="t?.buscaraccesos">
      <i class="fa fa-search"></i>
    </button>
  </div>

  <button
    *ngSwitchDefault
    type="button"
    class="sidebar-search-trigger"
    (click)="open()"
    [attr.aria-label]="t?.buscaraccesosmenu">
    <i class="fa fa-search"></i>
    <span class="sidebar-search-trigger-text">{{t?.buscaraccesos}}</span>
    <span class="sidebar-search-kbd">{{shortcutLabel}}</span>
  </button>
</ng-container>

<div *ngIf="isOpen" class="cmdk-overlay" (click)="close()">
  <div
    class="cmdk-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="t?.buscaraccesos"
    (click)="$event.stopPropagation()">

    <div class="cmdk-field">
      <i class="fa fa-search"></i>
      <input
        #searchInput
        type="text"
        name="sidebarSearch"
        class="cmdk-input"
        [(ngModel)]="sidebarSearchTerm"
        (keydown)="onInputKeydown($event)"
        [placeholder]="t?.buscaraccesos"
        [attr.aria-label]="t?.buscaraccesosmenu"
        autocomplete="off"
        role="combobox"
        aria-expanded="true"
        aria-controls="cmdk-listbox"
        [attr.aria-activedescendant]="results.length ? 'cmdk-opt-' + activeIndex : null">
      <button
        *ngIf="sidebarSearchTerm"
        type="button"
        class="cmdk-clear"
        (click)="clearSidebarSearch()"
        [attr.aria-label]="t?.limpiarbusqueda">
        <i class="fa fa-times"></i>
      </button>
      <span class="cmdk-kbd cmdk-kbd-esc">esc</span>
    </div>

    <div class="cmdk-results" id="cmdk-listbox" role="listbox">
      <a
        *ngFor="let item of results; let i = index; trackBy: trackBySidebarSearchItem"
        #resultAnchor
        [id]="'cmdk-opt-' + i"
        role="option"
        [attr.aria-selected]="i === activeIndex"
        class="cmdk-result"
        [class.is-active]="i === activeIndex"
        [routerLink]="[item.route]"
        routerLinkActive="router-link-active"
        (click)="onSidebarSearchResultClick()"
        (mouseenter)="activeIndex = i">
        <i class="{{item.icon}} cmdk-result-icon"></i>
        <span class="cmdk-result-copy">
          <span class="cmdk-result-label" [innerHTML]="item.labelHtml"></span>
          <span class="cmdk-result-context" *ngIf="item.moduleLabel || item.sectionLabel">
            {{item.moduleLabel}}<ng-container *ngIf="item.sectionLabel"> · {{item.sectionLabel}}</ng-container>
          </span>
        </span>
      </a>

      <div *ngIf="results.length === 0" class="cmdk-empty">
        {{t?.sinaccesosbusqueda}}
      </div>
    </div>
  </div>
</div>
